module.exports = __webpack_public_path__ + "static/media/IMG_1118.8b21cc20.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_1118.JPG
// module id = 441
// module chunks = 0